module.exports = __webpack_public_path__ + "images/emoji/money_with_wings.51a81371b5b728e1657c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/money_with_wings.png
// module id = kYnK
// module chunks = 1